import { useEffect, useState } from 'react';

export const SPLASH_FLAG = 'lag_post_login_splash';

export const BrandSplash = ({ visible = true }) => (
    <div className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#050505] transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        data-testid="brand-splash" aria-busy="true" aria-live="polite">
        <div className="pointer-events-none absolute inset-0 opacity-[0.08]" style={{ backgroundImage: 'radial-gradient(circle at 50% 40%, #f9e27a 0, transparent 45%)' }} />
        <div className="relative w-36 h-36 sm:w-44 sm:h-44 rounded-full overflow-hidden ring-2 ring-[#d4af37]/70 shadow-[0_0_60px_rgba(212,175,55,0.35)] splash-pop">
            <img src="/lions-advisory-logo.jpg" alt="Lions Advisory Group" className="w-full h-full object-cover" draggable="false" />
            <div className="splash-shine absolute inset-0" />
        </div>
        <p className="chrome-text mt-7 text-lg sm:text-2xl font-bold tracking-[0.35em] uppercase" style={{ fontFamily: 'Cinzel, serif' }} data-testid="brand-splash-title">
            Lions Advisory Group
        </p>
        <p className="mt-2 text-[11px] tracking-[0.3em] uppercase text-[#a3a3ab]">Preparando tu espacio</p>
        <div className="mt-6 w-40 h-[2px] rounded-full bg-white/10 overflow-hidden">
            <div className="splash-bar h-full w-1/3 rounded-full" />
        </div>
    </div>
);

export const PostLoginSplash = () => {
    const [state, setState] = useState(() => (sessionStorage.getItem(SPLASH_FLAG) ? 'show' : 'off'));
    useEffect(() => {
        if (!sessionStorage.getItem(SPLASH_FLAG)) return undefined;
        sessionStorage.removeItem(SPLASH_FLAG);
        const t1 = setTimeout(() => setState('fade'), 2200);
        const t2 = setTimeout(() => setState('off'), 2800);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, []);
    if (state === 'off') return null;
    return <BrandSplash visible={state === 'show'} />;
};
